import styles from "./list.module.css";

/**
 * Skeleton loader for the booking list screen.
 * Mirrors the real layout (toolbar, table on desktop, cards on mobile)
 * so there's no layout shift when the actual data arrives.
 */
const Bar = ({ width = "100%", height = 14, style = {} }) => (
    <div
        className={`${styles.SkeletonBlock}`}
        style={{ width, height, ...style }}
    />
);

const TABLE_COLS = [
    { width: "70px" },   // Booking Id
    { width: "60px" },   // Post Code
    { width: "110px" },  // Driver Name
    { width: "auto", grow: true }, // Pickup Address
    { width: "90px" },   // Contact No
    { width: "80px" },   // Pickup Date
    { width: "80px" },   // Assigned Date
    { width: "60px" },   // Action
];

const BookingListLoader = ({ rows = 6 }) => {
    return (<div className={`${styles.SkeletonWrap}`}>
        {/* Toolbar: search box, date filter, list/map switch */}
        <div className={`${styles.SkeletonToolbar}`}>
            <Bar width="240px" height={40} />
            <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
                <Bar width="180px" height={40} />
                <Bar width="96px" height={40} />
            </div>
        </div>

        <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px", marginBottom: "14px" }}>
            <Bar width="120px" height={36} />
            <Bar width="120px" height={36} />
        </div>

        {/* Desktop table skeleton */}
        <div className={`${styles.SkeletonTable}`}>
            <div className={`${styles.SkeletonTableHead}`}>
                {TABLE_COLS.map((col, i) => (
                    <Bar key={i} width={col.grow ? "100%" : col.width} height={12} style={{ flex: col.grow ? 1 : "0 0 auto" }} />
                ))}
            </div>

            {Array.from({ length: rows }).map((_, rowIdx) => (
                <div className={`${styles.SkeletonTableRow}`} key={rowIdx}>
                    {TABLE_COLS.map((col, colIdx) => (
                        <Bar
                            key={colIdx}
                            width={col.grow ? "100%" : col.width}
                            height={14}
                            style={{ flex: col.grow ? 1 : "0 0 auto" }}
                        />
                    ))}
                </div>
            ))}
        </div>

        {/* Mobile card skeleton */}
        <div className={`${styles.SkeletonCardList}`}>
            {Array.from({ length: rows }).map((_, i) => (
                <div className={`${styles.SkeletonCard}`} key={i}>
                    <div className={`${styles.SkeletonCardTop}`}>
                        <Bar width="90px" height={14} />
                        <Bar width="50px" height={14} />
                    </div>
                    <div className={`${styles.SkeletonCardRow}`}>
                        <Bar width="70px" height={12} />
                        <Bar width="110px" height={12} />
                    </div>
                    <div className={`${styles.SkeletonCardRow}`}>
                        <Bar width="90px" height={12} />
                        <Bar width="140px" height={12} />
                    </div>
                    <div className={`${styles.SkeletonCardRow}`}>
                        <Bar width="60px" height={12} />
                        <Bar width="90px" height={12} />
                    </div>
                    <div className={`${styles.SkeletonCardRow}`}>
                        <Bar width="80px" height={12} />
                        <Bar width="80px" height={12} />
                    </div>
                </div>
            ))}
        </div>
    </div>);
};

export default BookingListLoader;